import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const OptionsTitle = styled(Typography.Caption).attrs({
  $variant: '2',
})`
  position: sticky;
  z-index: 1;
  top: 0;
  color: ${({ theme }) => theme.palette.secondary.labels};
  padding: 10px 0;
  background-color: ${({ theme }) => theme.palette.primary.background};
`;
